import { useState } from "react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog/alert-dialog";

import { Button } from "@/components/ui/button/button";
import { Table } from "@tanstack/react-table";
import { UploadAttachment } from "./upload-attachement";
import { Input } from "@/components/ui/input/input";
import { toast } from "sonner";

interface AddSubtaskProps<TData> {
  table: Table<TData>;
}

export const AddDocument = <TData,>({ table }: AddSubtaskProps<TData>) => {
  const [open, setOpen] = useState(false);

  const [rowData, setRowData] = useState<{
    doc: string;
    url: string;
  }>({
    doc: "",
    url: "",
  });

  const onChangeFiles = (newFiles: string) => {
    setRowData((prev) => {
      return {
        ...prev,
        url: newFiles,
      };
    });
  };

  return (
    <>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogTrigger>
          <Button type="button" size="sm">
            Add Attachment
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent className="max-w-xl">
          <AlertDialogHeader>
            <AlertDialogTitle>Add Attachment</AlertDialogTitle>
          </AlertDialogHeader>

          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              <label htmlFor="doc">Name</label>
              <Input
                id="doc"
                name="doc"
                value={rowData.doc}
                onChange={(e) => {
                  setRowData((prev) => {
                    return {
                      ...prev,
                      [e.target.name]: e.target.value,
                    };
                  });
                }}
              />
            </div>

            <div className="">
              <UploadAttachment value={rowData.url} onChange={onChangeFiles} />
            </div>
          </div>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();

                if (rowData?.url === "") {
                  return toast.error(
                    "You've selected document but not uploaded, please upload."
                  );
                }
                // @ts-ignore
                table.options.meta?.addRow(rowData);

                setRowData({
                  doc: "",
                  url: "",
                });

                setOpen(false);
              }}
            >
              Add
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
